<template lang="pug">
    MatchMedia(v-slot='{ screenSM }')
        .main-layout__center
            .main-layout__top
                creator-search-control.main-layout__top-search(v-if='screenSM || !title')
                div.div.main-layout__top-back(v-else)
                    div(@click='back')
                        svg-icon(iconId='arrow-back')
                    div {{ title }}

                template(v-if='!screenSM')
                    compact-button-control(v-if='!editMode' :disabled='submitButtonDisabled' :loading="submitting" @click='submit')
                    compact-button-control(v-else @click='apply')
                main-layout-top-right(v-else)

            .main-layout__content-position
                .main-layout__content
                    div.post-create-edit-page__main(:class="theClass")
                        scrollable-layout.post-create-edit-page__left
                            div.post-create-edit-page__left-container
                                div.post-create-edit-page__head
                                    span {{ viewTitle }}
                                    button-control(:disabled='submitButtonDisabled' :loading="submitting" @click='submit') Post

                                div.post-create-edit-page__description.form-group
                                    textarea-field.post-create-edit-page__description-field(label='Text for Post' v-model='description' placeholder='Type your text here...')
                                        template(v-slot:controls="{ field }")
                                            creator-mention-dropdown-control(:textEl="field")

                                    div.post-create-edit-page__edit-controls
                                        div.post-create-edit-page__edit-control(@click="openMediaVault")
                                            svg-icon(iconId='picture')
                                        div.post-create-edit-page__edit-control(v-if="isCreator" @click='editLocker' :class='getEditControlClass(lockerData)')
                                            svg-icon(iconId='dollar')
                                        div.post-create-edit-page__edit-control(@click='editSchedule' :class='getEditControlClass(scheduleData.enabled)')
                                            svg-icon(iconId='schedule')

                                post-file-upload-control(v-model='files' :clickFileHandler='doEditFile' :allowVideo='true' @remove='fileRemoved' ref='uploadControl')

                        scrollable-layout.post-create-edit-page__right
                            div.post-create-edit-page__right-container
                                div.post-create-edit-page__right-content
                                    image-editor-control(
                                        v-if='editModeImage'
                                        :key='editFile.previewUrl || editFile.url'
                                        :image='editFile.file || editFile.url'
                                        :watermark="editFile.watermark"
                                        @change='updateImage'
                                        @changeTab='changeEditorTab'
                                        ref='imageEditor'
                                    )
                                    video-editor-control(
                                        v-if="editModeVideo"
                                        :key="editFile.previewUrl || editFile.url"
                                        :video="editFile"
                                        :watermark="editFile.watermark"
                                        @change="updateVideo"
                                        @changeTab="changeEditorTab"
                                        ref="videoEditor"
                                    )
                                    locker-editor-control(
                                        v-if='editModeLocker'
                                        :value='lockerData'
                                        :userSubscriptionProducts="userSubscriptionProducts"
                                        @change='updateLocker'
                                        ref='lockerEditor'
                                    )
                                    schedule-editor-control(
                                        v-if='editModeSchedule'
                                        :value='scheduleData'
                                        :disabled="postHasUserInteraction"
                                        @change='updateSchedule'
                                        ref='scheduleEditor'
                                    )

                                div.post-create-edit-page__right-actions(v-if='editMode')
                                    button-control(mode='cancel' @click='cancel') Cancel
                                    button-control(@click='apply') Apply

            .main-layout__bottom
</template>

<script>
import { MatchMedia } from 'vue-component-media-queries'
import { mapGetters } from 'vuex'
import PostService from '../../services/post-service'
import MediaVaultService from '../../services/media-vault-service'
import UserProductsService from '../../services/user-products-service'
import EventBus from '../../lib/event-bus'
import Events from '../../lib/events'
import ModalsList from '../../components/modals/modals-list'

export default {
    name: 'post-create-edit-page',

    components: {
        MatchMedia,
    },

    props: {
        postId: {
            type: String,
        },
    },

    data() {
        return {
            description: '',
            files: [],
            lockerData: null,
            scheduleData: {},
            postHasUserInteraction: false,
            editMode: null,
            editFile: null,
            editorTab: null,
            userSubscriptionProducts: null,
            submitting: false,
        }
    },

    computed: {
        ...mapGetters(['authUser']),

        isCreator() {
            return this.authUser.creator
        },

        editModeImage() {
            return this.editMode == 'image'
        },
        editModeVideo() {
            return this.editMode == 'video'
        },
        editModeLocker() {
            return this.editMode == 'locker'
        },
        editModeSchedule() {
            return this.editMode == 'schedule'
        },

        title() {
            if ((this.editModeImage || this.editModeVideo) && this.editorTab) {
                return this.editorTab
            }
            if (this.editModeLocker) {
                return 'Content Locker'
            }
            if (this.editModeSchedule) {
                return 'Post Schedule'
            }
            return this.viewTitle
        },
        viewTitle() {
            return this.postId ? 'Edit Post' : 'Create a New Post'
        },
        submitButtonDisabled() {
            return !this.description && this.files.length == 0;
        },

        theClass() {
            return {
                'post-create-edit-page--editing': this.editMode,
            }
        },
    },

    watch: {
        postId() {
            this.cancel()
            this.load()
        },
    },

    methods: {
        openMediaVault() {
            EventBus.$emit(Events.OPEN_MODAL, ModalsList.SELECT_MEDIA_VAULT_FILES, {
                title: 'Add to Post',
                confirmButtonText: 'Add to Post',
                selected: (fileIds) => {
                    MediaVaultService.toPostFiles(fileIds).then(r => {
                        const postFiles = r.data
                        postFiles.forEach(file => file.insert = true)
                        this.files.push(...postFiles)
                        this.$refs.uploadControl.setFiles(this.files)
                    })
                },
            })
        },

        doEditFile(file, raw) {
            const editFile = {
                ...file,
                url: raw.original_url,
                watermark: raw.watermark_options,
            }

            this.confirmCloseMode(editFile.type, () => {
                this.editFile = editFile
                this.editMode = editFile.type
            }, editFile)
        },

        fileRemoved(file) {
            if (this.editMode && file.file === this.editFile.file) {
                this.cancel()
            }
        },

        updateImage(file) {
            this.$refs.uploadControl.uploadFile(file, this.editFile.id)
            this.editMode = null
            this.editFile = null
        },

        async updateVideo(file, data) {
            await this.$refs.uploadControl.uploadVideoFileChanges(file, this.editFile.id, {data})
            this.editMode = null
            this.editFile = null
        },

        editLocker() {
            this.confirmCloseMode('locker', () => {
                this.editMode = 'locker'
            })
        },

        editSchedule() {
            this.confirmCloseMode('schedule', () => {
                this.editMode = 'schedule'
            })
        },

        updateLocker(lockerData) {
            this.lockerData = lockerData
            this.editMode = null
        },

        updateSchedule(scheduleData) {
            this.scheduleData = scheduleData
            this.editMode = null
        },

        confirmCloseMode(newMode, approve, file) {
          const needsConfirmation = this.editMode && (this.editMode != newMode ||
            (file && newMode === 'video' && this.editFile.url !== file.url))

            if (needsConfirmation) {
                const nameMap = {
                    image: 'media',
                    video: 'media',
                    locker: 'content locker',
                    schedule: 'schedule',
                }

                const text = `Your ${nameMap[this.editMode]} settings are not saved. Are you sure you want to ${newMode ? 'close it' : 'post'}?`

                EventBus.$emit(Events.OPEN_MODAL, ModalsList.GENERIC_CONFIRMATION, {
                    text,
                    approve,
                })
            }
            else {
                approve()
            }
        },

        async apply() {

            if (this.editModeVideo) {
                await this.$refs.videoEditor.apply()
            }
            if (this.editModeImage) {
                this.$refs.imageEditor.apply()
            }
            else if (this.editModeLocker) {
                this.$refs.lockerEditor.apply()
            }
            else if (this.editModeSchedule) {
                this.$refs.scheduleEditor.apply()
            }
        },

        async load() {
            if (this.postId) {
                const { data } = await PostService.get(this.postId)
                const post = data.data

                this.description = post.content.description
                this.files = post.files.data.filter(f => !f.group)

                if (post.content.locker) {
                    this.lockerData = {
                        ...post.content.locker,
                        thumbnailImage: post.files.data.find(f => f.group == 'locker-thumbnail'),
                    }
                }
                else {
                    this.lockerData = null
                }

                this.scheduleData = post.schedule_options || {}

                this.postHasUserInteraction = post.has_user_interaction
            }
            else {
                this.description = ''
                this.files = []
                this.lockerData = null
                this.scheduleData = {}
                this.postHasUserInteraction = false
            }

            this.$refs.uploadControl.setFiles(this.files)
        },

        submit() {
            this.confirmCloseMode(null, () => {
                if (this.$refs.uploadControl.checkUploadActive()) {
                    EventBus.$emit(Events.OPEN_MODAL, ModalsList.GENERIC_INFO, {
                        text: 'Media is uploading, please wait.'
                    })
                    return
                }

                const files = [...this.files]

                let locker = null
                if (this.lockerData) {
                    const { thumbnailImage, ...lockerData } = this.lockerData

                    locker = lockerData

                    if (thumbnailImage) {
                        files.push(thumbnailImage)
                    }
                }

                if (locker && files.length == 0) {
                    EventBus.$emit(Events.OPEN_MODAL, ModalsList.GENERIC_INFO, {
                        text: 'At least one media file is required for Content Locker.'
                    })
                    return
                }

                if (this.postId) {
                    this.submitting = true
                    PostService.update(this.postId, this.description, files.map(f => f.id), locker, this.scheduleData).then(() => {
                        this.submitting = false
                        this.$router.push(`/post/${this.postId}`)
                    })
                }
                else {
                    this.submitting = true
                    PostService.store(this.description, files.map(f => f.id), locker, this.scheduleData).then(() => {
                        this.submitting = false
                        this.$router.push('/')
                    })
                }
            })
        },

        cancel() {
            this.editMode = null
            this.editorTab = null
        },

        changeEditorTab(tab) {
            this.editorTab = tab.label
        },

        getEditControlClass(active) {
            return {
                'post-create-edit-page__edit-control--active': active,
            }
        },

        back() {
            this.editMode ? this.cancel() : this.$router.back()
        },
    },

    async created() {
        this.userSubscriptionProducts = await UserProductsService.byType(this.authUser.id, 'subscription')
    },

    mounted() {
        this.load()
    },
}
</script>
